import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import { Google, GoogleTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

/**
 *
 * @summary Google, Adobe click for vehicle warranty info on vdp
 * warrantyType examples: limited, factory, peace of mind, and added protection
 */
export async function inventoryWarrantyDetailClick(metadata, option) {

    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;

    const { warrantyType, inventoryId } = data;
    const pageName = _get(dataLayer, 'page.pageName', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);

    const type = warrantyType.toLowerCase();
    const element = `vdp_${data?.listingType.toLowerCase()}`;
    const eventData = {
        vehicle: { ...vehicleData },
    };

    let cmp = `cta::view-details::${_kebabCase(type)}`;

    if (['limited', 'factory'].includes(type)) {
        cmp = `cta::see-details::${type}-warranty`;
    }

    Google.sendClickEvent({
        eventElement: element,
        eventAction: 'click',
        eventResult: cmp,
        eventData,
    }, option);

    return { cmp, element };

}
